import React from 'react';
import { shortCurrency } from '@app/utils/formatters';
import { Flex, Typography, Tag, Button, Avatar, theme } from '@app/ui';
import {
    TopSponsorsGroupBy,
    TopSponsorData,
} from '../../hooks/useTopSponsorsCard';

interface TopItemButtonProps {
    groupBy: TopSponsorsGroupBy;
    isSelected: boolean;
    indexItem: number;
    item: TopSponsorData;
    accentColor: string;
    toggleOption: (itemId: number) => void;
}

const TopItemButton = ({
    groupBy,
    isSelected,
    indexItem,
    item,
    accentColor,
    toggleOption,
}: TopItemButtonProps) => {
    const {
        token: { colorPrimary },
    } = theme.useToken();

    return (
        <Button
            style={{
                justifyContent: 'space-between',
                padding: '24px 10px',
                margin: '2px 0',
                borderColor: 'transparent',
                borderBottom: `1px solid #0000000F`,
                borderRadius: 0,
                boxShadow: 'none',
                backgroundColor: isSelected
                    ? 'rgba(186, 224, 255, 0.70)'
                    : 'transparent',
            }}
            type={isSelected ? 'primary' : undefined}
            onClick={() => toggleOption(item.id)}
        >
            <Flex justify="space-between" gap={4} style={{ width: '100%' }}>
                <Flex gap={16}>
                    <Avatar
                        src={
                            item.logoUrl ? (
                                <img
                                    src={item.logoUrl}
                                    width={24}
                                    height={24}
                                    style={{ objectFit: 'contain' }}
                                />
                            ) : (
                                <i
                                    className="far fa-user"
                                    style={{ fontSize: 12 }}
                                />
                            )
                        }
                        size={24}
                        style={{
                            border: `1px solid ${colorPrimary}`,
                            background: item.logoUrl ? 'white' : accentColor,
                            color: 'white',
                        }}
                    />
                    <Typography.Text
                        style={{
                            whiteSpace: 'nowrap',
                            textAlign: 'left',
                            maxWidth: 265,
                        }}
                    >
                        {indexItem + 1}.{` `}
                        {item.name}
                    </Typography.Text>
                </Flex>
                <Tag
                    color={accentColor}
                    style={{
                        borderRadius: '6px',
                        padding: '0 8px',
                        margin: 0,
                        textAlign: 'center',
                    }}
                >
                    {groupBy === TopSponsorsGroupBy.smv
                        ? shortCurrency(item.smv, 1)
                        : item.exposures}
                </Tag>
            </Flex>
        </Button>
    );
};

export default TopItemButton;
